<div class="row" [class.print-mode]="printMode">
	<div class="col-12">
		<div class="top-exposure-image-container">
			<div class="exposure-picture">
				<img src="'assets/images/No_Image.png'" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" class="exposure-img">
			</div>
			<div class="exposure-date">
				<span>-</span>
			</div>
		</div>
	</div>

	<div class="col-12 platform-title">
		<span class="exposure-type-title">{{name}}</span>
	</div>

	<div class="col-12 d-flex justify-content-center align-items-center">
		<span class="exposure-count">-</span>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposure-item-placeholder/influencer-top-exposure-item-placeholder.component.html